/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BabylonBtcFinalityProviderDetailInfo } from '../models/BabylonBtcFinalityProviderDetailInfo';
import type { BabylonBtcFinalityProviderDetailRequest } from '../models/BabylonBtcFinalityProviderDetailRequest';
import type { BabylonBtcFinalityProviderListInfo } from '../models/BabylonBtcFinalityProviderListInfo';
import type { BabylonBtcFinalityProviderListRequest } from '../models/BabylonBtcFinalityProviderListRequest';
import type { BabylonBtcFinalityProviderSummaryIndicatorInfo } from '../models/BabylonBtcFinalityProviderSummaryIndicatorInfo';
import type { BabylonBtcStakerListByFinalityProviderPkRequest } from '../models/BabylonBtcStakerListByFinalityProviderPkRequest';
import type { BabylonBtcStakerListInfo } from '../models/BabylonBtcStakerListInfo';
import type { BabylonBtcStakingDistributionChartDailyInfo } from '../models/BabylonBtcStakingDistributionChartDailyInfo';
import type { BabylonBtcStakingTransactionListByFinalityProviderInfo } from '../models/BabylonBtcStakingTransactionListByFinalityProviderInfo';
import type { BabylonBtcStakingTransactionListByFinalityProviderRequest } from '../models/BabylonBtcStakingTransactionListByFinalityProviderRequest';
import type { BabylonFinalityProviderCountInfo } from '../models/BabylonFinalityProviderCountInfo';
import type { CommonEmptyRequest } from '../models/CommonEmptyRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class FinalityProviderControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBtcFinalityProviderIndicatorSummary({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<BabylonBtcFinalityProviderSummaryIndicatorInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/fp/indicator/summary',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBtcFinalityProviderDetail({
        requestBody,
    }: {
        requestBody: BabylonBtcFinalityProviderDetailRequest,
    }): CancelablePromise<BabylonBtcFinalityProviderDetailInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/fp/btc',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBtcStakingTransactionListByFinalityProvider({
        requestBody,
    }: {
        requestBody: BabylonBtcStakingTransactionListByFinalityProviderRequest,
    }): CancelablePromise<BabylonBtcStakingTransactionListByFinalityProviderInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/fp/btc/staking/transaction/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBtcStakingDailyDistributionChart({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<BabylonBtcStakingDistributionChartDailyInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/fp/btc/staking/distribution/chart/daily',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBtcStakerListByFinalityProviderPk({
        requestBody,
    }: {
        requestBody: BabylonBtcStakerListByFinalityProviderPkRequest,
    }): CancelablePromise<BabylonBtcStakerListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/fp/btc/staker/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBtcFinalityProviderList({
        requestBody,
    }: {
        requestBody: BabylonBtcFinalityProviderListRequest,
    }): CancelablePromise<BabylonBtcFinalityProviderListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/fp/btc/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBabylonFinalityProviderCount({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<BabylonFinalityProviderCountInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/fp/btc/count',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
